import { render, staticRenderFns } from "./ShareLandingComV2.vue?vue&type=template&id=175d4954&scoped=true"
import script from "./ShareLandingComV2.vue?vue&type=script&lang=js"
export * from "./ShareLandingComV2.vue?vue&type=script&lang=js"
import style0 from "./ShareLandingComV2.vue?vue&type=style&index=0&id=175d4954&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175d4954",
  null
  
)

export default component.exports